import {useErrorReporting} from "@unibuddy/error-reporting";
import {getErrorString} from "../utils/getErrorString";

export function usePostMessage() {
    const urlParams = new URLSearchParams(window.location.search);
    const parentUrl = urlParams.get("parentUrl") ?? "*";
    const {reportError} = useErrorReporting();

    const postMessage = (message: string) => {
        try {
            window.parent.postMessage(message, parentUrl.startsWith("file://") ? "*" : parentUrl);
        } catch (error) {
            console.error("Error posting message", error);

            reportError(
                new Error(
                    `Error posting message from usePostMessage hook: ${getErrorString(error)}`,
                ),
            );
        }
    };

    return {
        postMessage,
    };
}
